﻿import React from 'react';
import {Typography} from "@mui/material";

type CardHeaderTitleTextProps = React.ComponentPropsWithoutRef<'h6'>

/**
 * MUI Typography component styled in the SecurSpace way. Used in the HeaderItemContainer for adding a styled header
 * @param children children passed through to the internal Typography component
 * @param rest The rest of the Typography props that will be passed through to the internal Typography component
 * @constructor
 */
const CardHeaderTitleText = ({ children, ...rest}: CardHeaderTitleTextProps) => {
  return <Typography variant={'h6'} fontSize={'1.13rem'} {...rest}>
    { children }
  </Typography>
}

export { CardHeaderTitleText };
